/* eslint-disable */
import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = makeStyles({
  input: {
    color: "#444C67",
  },
  imgLabel: {
    color: "#444C67",
    fontFamily: "Nunito Sans",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0%",
  },
  messageBox: {
    width: "50%",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: "#d4edda",
    color: "#155724",
    position: "sticky",
    top: "5px",
    right: 0,
    margin: "8px 0 -30px 15px",
    zIndex: 1000,
  },
  msgError: {
    backgroundColor: "rgb(253, 236, 234)",
    color: "rgb(136, 37, 30)",
  },
  msgWarn: {
    backgroundColor: "rgb(255 152 0 / 22%)",
    color: "black",
  },
  btnInput: {
    backgroundColor: '#e8e8e8',
    width: 'max-content',
    paddingLeft: 14,
    paddingRight: 14,
    '&:hover': {
      backgroundColor: 'rgb(202, 189, 235, 0.7)',
    },
  },
  btnQube: {
    padding: 6,
    borderRadius: 4,
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
  },
  adornedStart: {
    padding: '0 !important',
  },
  adornedEnd: {
    padding: '0 !important',
  },
  label: {
    color: '#444C67',
    fontSize: "0.875rem",
    fontWeight: 500,
    marginBottom: '8px'
  },
  radioGroup: {
    display: 'flex',
    gap: '8px',
    marginTop: '8px'
  },
  radioButton: {
    margin: 0,
    borderRadius: '24px',
    padding: '8px 16px',
  },
  radioButtonSelected: {
    backgroundColor: '#444C67',
    '& .MuiFormControlLabel-label': {
      color: 'white',
      fontSize: '0.875rem',
      fontWeight: 500,
      margin: 0
    }
  },
  radioButtonUnselected: {
    backgroundColor: '#F0F2F4',
    '& .MuiFormControlLabel-label': {
      color: '#444C67',
      fontSize: '0.875rem',
      fontWeight: 500,
      margin: 0
    }
  },
  select: {
    width: '100%',
    height: '56px',
    borderRadius: '4px',
    color: '#444C67',
    border: '1px solid #E0E0E0',
    '&:hover': {
      border: '1px solid #BDBDBD',
    },
    '&:focus': {
      border: '1px solid #444C67',
    },
  },
});
